import React from 'react';
import { Box, Paper, Typography, TextField, Button } from '@mui/material';

const ChangePassword: React.FC = () => {
  return (
    <Box sx={{ maxWidth: 480, mx: 'auto', mt: 6 }}>
      <Paper elevation={0} sx={{ p: 4, borderRadius: 2, border: '1px solid #E5E7EB' }}>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 600, color: '#111827' }}>
          Change Password
        </Typography>
        <TextField
          label="Current Password"
          type="password"
          fullWidth
          margin="normal"
        />
        <TextField
          label="New Password"
          type="password"
          fullWidth
          margin="normal"
        />
        <TextField
          label="Confirm New Password"
          type="password"
          fullWidth
          margin="normal"
        />
        <Button variant="contained" sx={{ mt: 3 }}>Submit</Button>
      </Paper>
    </Box>
  );
};

export default ChangePassword; 